export default {"src":"/_next/static/media/approval_icon.a1ab649c.svg","height":92,"width":89,"blurWidth":0,"blurHeight":0};